const HorizontalDivider = () => {
  return <div className="w-full h-1 border-t" />;
};

export default HorizontalDivider;
